import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';
import { EnergyMonitorComponent } from './energy-monitor.component';
import { EnergyTabNavigationComponent } from './energy-tab-navigation/energy-tab-navigation.component';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'energy-monitor', component: EnergyMonitorComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Customer'] }
        },
      ]
    )
  ],
  providers: [
  ],
})
export class EnergyMonitorModule { }
